import { Component, OnInit, ViewChildren, ViewChild} from '@angular/core';
import { User } from '../_models/user';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from "angularx-social-login";
import { Title, Meta } from '@angular/platform-browser';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AuthenticationService } from '../authentication.service';
import { DamserviceService } from "../dam/damservice.service";
import { InboxservicesService } from "../inboxarea/inboxservices.service";
import { UploadFilesService } from 'src/app/services/upload-files.service';
import { OrganisationService } from "../create-organisation/organisation.service";
import { PdfViewerComponent } from 'ng2-pdf-viewer';
import AOS from 'aos';

@Component({
  selector: 'app-verification',
  templateUrl: './verification.component.html',
  styleUrls: ['./verification.component.css']
})
export class VerificationComponent implements OnInit {

  boards = [];
  searchedBoards = [];
  imagesExtension: [];
  workspaces = [];
  fileInfos: [];
  imagesList = [];
  workspaceId: any
  workspaceName: string;
  boardId: any;
  mobileView: boolean = false;
  currentUser: User;
  totalIllusCount: any;
  planName: string;
  ownerEmail: string;
  ownerName: string;
  totalSpaceAllowed: any;
  consumedSpaceAllowed: any;
  totalSpaceAllowedProgress: any;
  userRole: string;
  boardHeading: string = '';
  workspaceTitle: string;
  boardStatus: any;
  boardname: string = '';
  currentBoard: any;
  sendSuccessful: boolean = false;
  errorSuccessfull: boolean = false;
  showLeaveLoader: boolean = false;
  showLeaveLoaderReject: boolean = false;
  successMsg: any;
  errorMsg: any

  deleteBoardStyle = "none";
  downloadImagesStyle = "none";
  deleteBoardId: any;
  deleteBoardName: string;
  boardIdsList = [];
  boardApproveId: any;
  boardApprovalList = [];
  imagesApprovalList = [];

  public selectedIndex;
  public index;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private authService: AuthService,
    private modalService: NgbModal,
    private authenticationService: AuthenticationService,
    private damService: DamserviceService,
    private inboxService: InboxservicesService,
    private organisationService: OrganisationService,
    private uploadService: UploadFilesService,
    private titleService: Title,
    private metaTagService: Meta,
  ) { }

  @ViewChildren("checkboxes") checkboxes;

  ngOnInit(): void {
    this.metaTagService.addTags([
      { name: 'description', content: 'Crafttor Workspace provides you with number of boards you created and upload images to your boards keeping it secure and smooth to access images anytime.'},
      { name: 'keywords', content: 'boards, board, workspace, upload free illustrations, upload clean pixel illustrations, upload premium illustration, ' },
      { name: 'robots', content: 'index, follow' },
      { name: 'author', content: 'Crafttor' },
      { name: 'viewport', content: 'width=device-width, initial-scale=1' },
      { charset: 'UTF-8' }
    ]);

    AOS.init();

    this.authenticationService.currentUser.subscribe(x => { this.currentUser = x });
    if (window.screen.width <= 991) { // 768px portrait
      this.mobileView = true;
    }else{
      this.mobileView = false;
    }

    var details = JSON.parse(localStorage.getItem('workspaceDetails'));
    this.workspaceId = details.workspaceId;
    this.workspaceName = details.workspaceName;
    this.route.paramMap.subscribe(params => {
    this.boardId = params.get('boardId');
    this.titleService.setTitle("Verification | Workspace | Crafttor");
    this.getWorkspaceDetails();
    });
  }

  getWorkspaceDetails(){
    var details = JSON.parse(localStorage.getItem('workspaceDetails'));
    var boardDetails = JSON.parse(localStorage.getItem('boardDetails'));
    var editBoardDetails = JSON.parse(localStorage.getItem('editBoardDetails'));
    var verificationDetails = JSON.parse(localStorage.getItem('verificationDetails'));
    this.workspaceId = details.workspaceId;
    this.workspaceName = details.workspaceName;
    this.boardIdsList.push(verificationDetails.approvalId);
    this.boardApproveId = verificationDetails.approvalId;
    this.boardHeading = verificationDetails.assetTitle;
    this.workspaceTitle = verificationDetails.workspaceTitle;
    this.boardStatus = verificationDetails.boardStatus;
    this.getCurrentUserData(this.workspaceId);
    this.boardId = boardDetails.boardId;
    this.index = boardDetails.boardIndex;
    this.listWorkspace();
    this.damService.getBoardsList(this.workspaceId).subscribe((data: any) => {
      this.boards = data;
    });

    if (this.boardStatus == 'Approved') {
      this.sendSuccessful = true;
      this.successMsg = "Already Approved";
      this.hideSuccesfullFunction();
    } else if (this.boardStatus == 'Rejected') {
      this.errorSuccessfull = true;
      this.errorMsg = "Already Rejected";
      this.hideSuccesfullFunction();
    }
  }

  listWorkspace(){
    if (this.currentUser) {
      this.organisationService.getWorkspaceList().subscribe((data: any) => {
        if(data.length > 0){
          this.workspaces = data;
          this.ownerListApi();
        }else{
            this.router.navigate(['/create-workspace']);
          }
      });
    }else{
        this.router.navigate(['/login']);
    }
  }

  getCurrentUserData(workspaceId: any) {
    this.damService.getCurrentUserData(workspaceId).subscribe((data: any) => {
      this.userRole = data.role;
    });
  }

  selectWorkspace(id: any, title: string, userRole: string){
    this.workspaceName = title;
    this.workspaceId = id;
    this.getCurrentUserData(this.workspaceId);
    localStorage.setItem('workspaceDetails', JSON.stringify({ workspaceId: id,
      workspaceName: title, userRole: userRole }));
    this.router.navigate(['/dam']);
  }

  ownerListApi(){
    this.damService.getOwnerList(this.workspaceId).subscribe((data: any) => {
      this.ownerEmail = data.email;
      this.planName = data.plan_title;
      this.ownerName = data.first_name + " " + data.last_name;
      this.totalSpaceAllowed = data.allowed_dam_space_kb/1000000
      this.consumedSpaceAllowed = data.current_dam_space/1000
      this.totalSpaceAllowedProgress = data.allowed_dam_space_kb/1000
      this.getBoardApprovalList();
    });
  }

  imageExtensionApi(){
    this.damService.imagesExtension(this.workspaceId, this.boardId).subscribe((data: any) => {
      this.imagesExtension = data['image_formats'];
    });
  }

  openDeleteBoardShare(boardId: any, boardName: string) {
    this.deleteBoardId = boardId;
    this.deleteBoardName = boardName;
    this.deleteBoardStyle = "block";
  }

  closeDeleteBoardShare() {
   this.deleteBoardStyle = "none";
  }

  openDownloadImagesStyleBoard(){
    this.downloadImagesStyle = "block";
  }

  closeDownloadImagesStyleBoard() {
   this.downloadImagesStyle = "none";
  }

  selectFilter(e, searchTxt: string){
    if(e.target.checked){
      this.filterImages(this.boardId, searchTxt);
    }else{
      this.filterRemoveImages(this.boardId, searchTxt);
    }
  }

  formatList = [];

  filterImages(boardId: any, searchText: string){
    this.showLeaveLoader = false;
    this.formatList.push(searchText);
    this.damService.filterImage(this.workspaceId, boardId, this.formatList).subscribe((data: any) => {
      this.fileInfos = data['results'];
      this.totalIllusCount = data['results'].length;
    });
  }

  filterRemoveImages(boardId: any, searchText: string){
    this.showLeaveLoader = false;
    this.formatList.forEach((element,index)=>{
      if(element==searchText) delete this.formatList[index];
    });
    if(this.formatList.length == 0){
      this.formatList = [];
      this.damService.filterImage(this.workspaceId, boardId, this.formatList).subscribe((data: any) => {
        this.fileInfos = data['results'];
        this.totalIllusCount = data['results'].length;
      });
    }else{
      this.damService.filterImage(this.workspaceId, boardId, this.formatList).subscribe((data: any) => {
        this.fileInfos = data['results'];
        this.totalIllusCount = data['results'].length;
      });
    }
  }

  changeColors(i){
      this.selectedIndex = i;
  }

  clearFilter(){
    this.showLeaveLoader = false;
    this.checkboxes.forEach((element) => {
      element.nativeElement.checked = false;
    });
    this.formatList = [];
    this.damService.filterImage(this.workspaceId, this.boardId, this.formatList).subscribe((data: any) => {
      this.fileInfos = data['results'];
      this.totalIllusCount = data['results'].length;
    });
  }

  backToInbox() {
    this.router.navigate(['dam/inbox']);
  }

  deleteBoard(){
    this.showLeaveLoader = false;
    this.selectedIndex = -1;
    this.damService.deleteBoard(this.workspaceId, this.deleteBoardName,
      this.deleteBoardId).subscribe((data: any) => {
      this.closeDeleteBoardShare();
      this.allMediaRedirect();
    });
  }

  allMediaRedirect(){
    this.router.navigate(['/dam']);
  }

  hideSuccesfullFunction(){
    setTimeout(() => {
      this.sendSuccessful = false;
      this.errorSuccessfull = false;
    }, 3000);
  }

  getWorkspaceId(workId: any) {
    this.workspaceId = workId;
  }

  getBoardApprovalList () {
    this.showLeaveLoader = false;
    this.inboxService.getApprovalBoardsList(this.workspaceId, this.boardId).subscribe((data: any) => {
      this.boardApprovalList = data;
      this.getAssetsList();
    });
  }

  getBoardApprovalListAfterStatus () {
    this.showLeaveLoader = false;
    this.boardIdsList = [];
    this.inboxService.getApprovalBoardsList(this.workspaceId, this.boardId).subscribe((data: any) => {
      this.boardApprovalList = data;
      for (let img of data) {
        if(img.status == 'Pending') {
          this.boardApproveId = img.board_approval_id;
          this.boardIdsList.push(img.board_approval_id);
          this.boardHeading = img.board_title;
          this.workspaceTitle = img.workspace_title;
          this.boardStatus = img.status;
        }
      }
      this.getAssetsList();
    });
  }

  approveBoard(boardIds: any, verifyId: any) {
    this.showLeaveLoader = false;
    this.boardIdsList.push(boardIds);
    this.inboxService.approveBoards("0", this.boardIdsList, verifyId).subscribe((data: any) => {
      this.boardIdsList = [];
      this.imagesApprovalList = [];
      this.router.navigate(['dam/inbox/']);
    });
  }

  approveBoardBtn(verifyId: any) {
    this.showLeaveLoaderReject = false;
    this.showLeaveLoader = true;
    this.inboxService.approveBoards("0", this.boardApproveId, verifyId).subscribe((data: any) => {
      this.boardIdsList = [];
      this.showLeaveLoader = false;
      this.imagesApprovalList = [];
      this.getBoardApprovalListAfterStatus();
      this.router.navigate(['dam/inbox/']);
    },
    (error) => {
      this.showLeaveLoader = false;
      if(error.status == 403){
        this.showLeaveLoader = false;
      } else {
        this.showLeaveLoader = false;
      }
   });
  }

  rejectBoardBtn(verifyId: any) {
    this.showLeaveLoader = false;
    this.showLeaveLoaderReject = true;
    this.inboxService.approveBoards("0", this.boardApproveId, verifyId).subscribe((data: any) => {
      this.boardIdsList = [];
      this.showLeaveLoaderReject = false;
      this.imagesApprovalList = [];
      this.getBoardApprovalListAfterStatus();
      this.router.navigate(['dam/inbox/']);
    },
    (error) => {
      this.showLeaveLoaderReject = false;
      if(error.status == 403){
        this.showLeaveLoaderReject = false;
      } else {
        this.showLeaveLoaderReject = false;
      }
   });
  }

  boardlistClick(boardName: string, boardId: any, workspaceTitle: string, currentStatus: any){
    this.showLeaveLoaderReject = false;
    this.showLeaveLoader = false;
    this.boardHeading = boardName;
    this.boardname = boardName;
    this.boardIdsList.push(boardId);
    this.imagesApprovalList = [];
    this.boardApproveId = boardId;
    this.workspaceTitle = workspaceTitle;
    this.boardStatus = currentStatus;
    this.inboxService.getApprovalBoardsList(this.workspaceId, this.boardIdsList).subscribe((data: any) => {
      this.boardApprovalList = data;
      this.getAssetsList();
      this.boardIdsList = [];
    });
  }

  getAssetsList(){
    this.showLeaveLoaderReject = false;
    this.showLeaveLoader = false;
    this.inboxService.getAssetsList(this.workspaceId, this.boardIdsList).subscribe((data: any) => {
      this.imagesApprovalList = data;
      this.totalIllusCount = data.length;
      this.boardIdsList = [];
    });
  }

  @ViewChild(PdfViewerComponent, {static: false})
  private pdfComponent: PdfViewerComponent;
  pageRendered() {
    this.pdfComponent.pdfViewer.currentScaleValue = 'page-fit';
  }
}
